export default "__VITE_PUBLIC_ASSET__19f987a5__"